var Opacities;
(function (Opacities) {
    Opacities[Opacities["full"] = 1] = "full";
    Opacities[Opacities["medium"] = 0.6] = "medium";
    Opacities[Opacities["low"] = 0.3] = "low";
    Opacities[Opacities["xLow"] = 0.15] = "xLow";
    Opacities[Opacities["none"] = 0] = "none";
})(Opacities || (Opacities = {}));
export default Opacities;
export const createCustomOpacity = (value) => value;
